import { render } from "./LightSearch.vue?vue&type=template&id=0b30eb07"
import script from "./LightSearch.vue?vue&type=script&lang=js"
export * from "./LightSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__